import React from 'react';
import ChurnRatioChart from '../charts/ChurnRatioChart';

/**
 * Card wrapper for the Churn Ratio chart (deletions / (additions + deletions) per day).
 */
const ChurnRatioCard = ({
  loading,
  noData,
  dates = [],
  ratios = [],
  windowDays,
  period,
  chartType,
  onPeriodChange,
  onChartTypeChange,
  emptyMessage = 'No commit data in this window.',
  className = '',
}: any) => {
  const hasChartData =
    Array.isArray(dates) &&
    dates.length > 0 &&
    Array.isArray(ratios) &&
    ratios.length === dates.length;

  return (
    <div className={`card-mdl-static p-4 min-w-0 h-full ${className}`.trim()}>
      {noData && !loading ? (
        <p className="text-sm text-slate-400">{emptyMessage}</p>
      ) : (
        <ChurnRatioChart
          dates={hasChartData ? dates : []}
          ratios={hasChartData ? ratios : []}
          windowDays={windowDays}
          period={period}
          chartType={chartType}
          onPeriodChange={onPeriodChange}
          onChartTypeChange={onChartTypeChange}
          loading={loading}
        />
      )}
    </div>
  );
};

export default ChurnRatioCard;
